import { FC, useState } from 'react';
import { useRouter } from 'next/router';
import EfSwiperLevel2 from '@elem/ui/ef-swiper-level2';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.SwiperJpB');
    const { locale } = useRouter();
    const [listA, setListA] = useState([
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737787946144/8_1.jpg'
                    : locale === 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1720167688778/Cost-efficient%20and%20hassle%20free.1.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718867209061/a1%20(1).jpg',
            h5:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737787946424/8_1_M.jpg'
                    : locale === 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1720167744838/Frame%201000008480.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718881548265/cc1%20(1).jpg',
            upTitle: t('item1_t'),
            subtitle: t('item1_l'),
            desc: t('item1_r'),
        },
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737787945753/8_2.jpg'
                    : locale === 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1720167932109/3602.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718851894532/3602.jpg',
            h5List:
                locale === 'cn'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1737787945573/8_2_1_M.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1737787945945/8_2_2_M.jpg',
                      ]
                    : [
                          locale === 'jp'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1720168210056/Frame%201000008475.jpg'
                              : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718852234145/a2-1.jpg',
                          'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718852256061/a2-2.jpg',
                      ],
            upTitle: t('item2_t'),
            subtitle: t('item2_l'),
            desc: t('item2_r'),
        },
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737787946989/8_3.jpg'
                    : locale === 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1720167976906/3603.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718851907725/3603.jpg',
            h5List:
                locale === 'cn'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1737787947344/8_3_1_M.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1737787947164/8_3_2_M.jpg',
                      ]
                    : [
                          locale === 'jp'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1720168252181/Frame%201000008476.jpg'
                              : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718852274915/a3-1.jpg',
                          'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718852288315/a3-2.jpg',
                      ],
            upTitle: t('item3_t'),
            subtitle: t('item3_l'),
            desc: t('item3_r'),
        },
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737787947516/8_4.jpg'
                    : locale === 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1720168032109/3604.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718851922756/3604.jpg',
            h5List:
                locale === 'cn'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1737787946787/8_4_1_M.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1737788134330/8_4_2_M.jpg',
                      ]
                    : [
                          locale === 'jp'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1720168271177/Frame%201000008478.jpg'
                              : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718852308601/a4-1.jpg',
                          'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718852325645/a4-2.jpg',
                      ],
            upTitle: t('item4_t'),
            subtitle: t('item4_l'),
            desc: t('item4_r'),
        },
    ]);
    return (
        <div
            id="dp3-teaser-E14"
            className={`Smoothly dp3-teaser-E ${styles.theComp} GtmModuleData-section`}
            data-section-id={'dp3-SwiperJpB'}
            data-section-title={t('title')}
        >
            <div className="dp3-module-box comp-module">
                <div className="dp3-title">{t('title')}</div>
                {/* <SwiperCommon list={listA} /> */}
            </div>
            <EfSwiperLevel2 list={listA} hasLevel2={true} />
        </div>
    );
};

export default TheComp;
